export const OAUTH_CLIENT_ID = process.env.REACT_APP_CLIENT_ID as string;
// Для разработки временно переменные .env вынесены в глобал
export const BASE_API_URL =
  process.env.REACT_APP_BASE_API_URL || ('https://panel-dev.adway.team/api' as string);
export const BASE_URL = process.env.REACT_APP_BASE_URL || ('https://panel-test.adway.team' as string);
export const WEB_SOCKET_URL =
  process.env.REACT_APP_WEB_SOCKET_URL || ('wss://panel-test.adway.team/ws' as string);
export const BASE_FMBANAGER_API_URL = process.env.REACT_APP_BASE_FMBANAGER_API_URL as string;
export const IMAGE_BUCKET_URL =
  process.env.REACT_APP_IMAGE_BUCKET_URL || ('https://static.joxi.pro' as string);
export const TOKEN = localStorage.getItem('token');
export const USER_AVATAR_FOLDER = '/uploads/users';
export const GOOGLE_TRANSLATE_API_URL = 'https://google-translate113.p.rapidapi.com/api/v1/translator/text';
export const GOOGLE_TRANSLATE_TOKEN = process.env.REACT_APP_GOOGLE_TRANSLATE_TOKEN as string;
export const VIDEO_PLAYER_URL = process.env.REACT_APP_VIDEO_PLAYER_URL as string;
